<div class="p-3">
  <h5 class="nmbcol">{{ 'Sellers.Products.AddInvoiceItems' | translate }}</h5>
  <div class="col-12">
    <div class="cardbg-white">
      <div class="row">
        <table class="table mb-1" [formGroup]="InvoiceItemsForm">
          <tbody formArrayName="Invoice_Items">
            <tr *ngFor="let item of InvoiceItems.controls; let i = index" class="row align-items-center mx-0">
              <td class="col-md-3" [formGroupName]="i">
                <app-text [fieldObject]="itemController['Item Name']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertInvoiceItemsControls(i, 'Item Name')" [productType]="productTypeId"
                  [isUpdate]="isUpdate"></app-text>
              </td>
              <td class="col-md-3" [formGroupName]="i">
                <app-number [fieldObject]="itemController['Price']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertInvoiceItemsControls(i, 'Price')" [productType]="productTypeId"
                  [isUpdate]="isUpdate"></app-number>
              </td>
              <td class="col-md-3" [formGroupName]="i">
                <app-number [fieldObject]="itemController['Quantity']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertInvoiceItemsControls(i, 'Quantity')" [productType]="productTypeId"
                  [isUpdate]="isUpdate"></app-number>
              </td>
              <td class="col-md-auto">
                <span class="removeItem text-danger" title="Delete"
                  (click)="removeItems(i)" *ngIf="InvoiceItems.controls.length > 0">
                    <i class="fa fa-trash" style="transform: scale(1.3)"
                  title="Delete form field row"></i>
             </span>
              </td>
            </tr>
          </tbody>
        </table>
        <button type="button" [disabled]='InvoiceItems.invalid' class="btn btn-success w-100 py-1 mx-0"
          (click)="addInvoiceItems()">
          {{ 'Sellers.Products.AddItem' | translate }}
        </button>
        <div class="d-flex px-0 py-2 justify-content-end" style="margin-left: -5px;"><span class="total-section">{{
            'Sellers.Products.Total' | translate }} : {{ total.toFixed(2) }}</span></div>
        <div *ngIf="noItem==true" class="text-danger">
          {{ 'Sellers.Products.CompleteOneInvoice' | translate }}
        </div>
      </div>
    </div>
    <div class="cardbg-white my-3">
      <div class="row">
          <app-invoice-step-four *ngIf="productObject" [productObject]="productObject"></app-invoice-step-four>
          <app-invoice-step-four *ngIf="!productObject"></app-invoice-step-four>
      </div>
    </div>
    <div class="col-12">
      <div class="cardbg-white my-3">
        <div class="row">
          <app-toggle [fieldObject]="controllers['is_buyer_info']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertStepFormControls(controllers['is_buyer_info'].fieldName)" [isUpdate]="isUpdate">
          </app-toggle>
        </div>
      </div>
    </div>
